module.exports = __webpack_public_path__ + "static/Image07@2x-40b8becfab0c9eae97dc3f730bc19eb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image07@2x.jpg
// module id = 900
// module chunks = 227233210825294 244429959259914